module.exports = __webpack_public_path__ + "img/cns_email_ios11.903fd1a8.png";